module.exports = __webpack_public_path__ + "img/SES_160254101.45fcc72c.jpg";